import clsx from 'clsx';
import React from 'react';
import { convertTag } from 'global/utils/convertTag';
import { UserStatus } from 'types/userService';
import { EmployeeInvitationStatusTypes, SubscriberSERoles } from 'types/electionService';
import { createStyles } from './styles';
import { SUBSCRIBER_STATUS_TAG_TEST_ID } from '../constants';

export interface SubscriberStatusProps {
  status: EmployeeInvitationStatusTypes | UserStatus;
  subSERole?: SubscriberSERoles;
  size?: 'small' | 'large';
}

const SubscriberStatus: React.FC<SubscriberStatusProps> = ({ status, subSERole, size = 'large' }) => {
  const classes = createStyles();

  const createStatus = (): JSX.Element => {
    switch (subSERole) {
      case SubscriberSERoles.EMPLOYER:
        return (
          <div className={clsx(classes.tag, classes[`tag_${size}`], classes[`tagType${SubscriberSERoles[subSERole]}`])}>
            {convertTag(SubscriberSERoles[subSERole])}
          </div>
        );
      default:
        return (
          <div
            className={clsx(
              classes.tag,
              classes[`tag_${size}`],
              classes[
                `tagType${
                  EmployeeInvitationStatusTypes[status as EmployeeInvitationStatusTypes] ||
                  UserStatus[status as UserStatus]
                }`
              ],
            )}
            data-test-id={SUBSCRIBER_STATUS_TAG_TEST_ID}
          >
            {convertTag(
              EmployeeInvitationStatusTypes[status as EmployeeInvitationStatusTypes] ||
                UserStatus[status as UserStatus],
            )}
          </div>
        );
    }
  };

  return <>{createStatus()}</>;
};

export default SubscriberStatus;
